var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 25.0946C42.058 25.0946 43.7264 23.4263 43.7264 21.3683C43.7264 19.3102 42.058 17.6419 40 17.6419C37.942 17.6419 36.2737 19.3102 36.2737 21.3683C36.2737 23.4263 37.942 25.0946 40 25.0946Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2737 29.7525C35.5324 29.7525 34.8216 30.047 34.2975 30.5711C33.7733 31.0952 33.4789 31.8061 33.4789 32.5473C33.4789 33.2885 33.7733 33.9994 34.2975 34.5235C34.8216 35.0476 35.5324 35.3421 36.2737 35.3421V29.7525ZM40 32.5473H42.7948C42.7948 31.8061 42.5003 31.0952 41.9762 30.5711C41.4521 30.047 40.7412 29.7525 40 29.7525V32.5473ZM37.2052 58.6317C37.2052 59.3729 37.4997 60.0838 38.0238 60.6079C38.5479 61.132 39.2588 61.4265 40 61.4265C40.7412 61.4265 41.4521 61.132 41.9762 60.6079C42.5003 60.0838 42.7948 59.3729 42.7948 58.6317H37.2052ZM74.4687 40C74.4687 49.1417 70.8372 57.9089 64.3731 64.3731C57.9089 70.8372 49.1417 74.4687 40 74.4687V80.0582C62.1233 80.0582 80.0582 62.1233 80.0582 40H74.4687ZM40 74.4687C30.8583 74.4687 22.0911 70.8372 15.6269 64.3731C9.16281 57.9089 5.53129 49.1417 5.53129 40H-0.0582275C-0.0582275 62.1233 17.8767 80.0582 40 80.0582V74.4687ZM5.53129 40C5.53129 30.8583 9.16281 22.0911 15.6269 15.6269C22.0911 9.16281 30.8583 5.53129 40 5.53129V-0.0582275C17.8767 -0.0582275 -0.0582275 17.8767 -0.0582275 40H5.53129ZM40 5.53129C49.1417 5.53129 57.9089 9.16281 64.3731 15.6269C70.8372 22.0911 74.4687 30.8583 74.4687 40H80.0582C80.0582 17.8767 62.1233 -0.0582275 40 -0.0582275V5.53129ZM36.2737 35.3421H40V29.7525H36.2737V35.3421ZM37.2052 32.5473V58.6317H42.7948V32.5473H37.2052Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9408e927cdd06d0fd0109548a9028f1b.svg";
export { ForwardRef as ReactComponent };